// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"8fcf0d95","204":"a62d093a","210":"1a9c7b39","238":"a59fc41c","453":"639c15cb","760":"65f9b5d2","833":"d2141d6a"}[chunkId] + ".chunk.js";
};